<script>
import baseMixin from '@/mixins/baseMixin'
import BaseCheckbox from '@/components/_base-checkbox.vue'
import CandidateImage from '@/components/candidate/candidate-image.vue'
import BookingStatusLabel from '@components/booking/booking-status-label.vue'

export default {
  name: 'FilterPanel',
  components: {
    BaseCheckbox,
    CandidateImage,
    BookingStatusLabel,
  },
  mixins: [baseMixin],
  props: {
    title: { type: String, default: '' },
    name: { type: String, default: '' },
    selectedFilter: { type: Number, default: 0 },
    items: { type: Array, default: () => [] },
    valueKey: { type: String, required: true },
    labelKey: { type: [Array, String], required: true },
    localSelected: { type: Array, required: true },
    maxHeight: { type: Number, required: true },
    selectedCount: { type: Number, default: 0 },
  },
  emits: ['update:localSelected', 'clear', 'apply', 'back'],
  data() {
    return {
      internalSelected: [...this.localSelected],
    }
  },
  methods: {
    getLabel(item) {
      return Array.isArray(this.labelKey)
        ? this.labelKey.map((k) => item[k]).join(' ')
        : item[this.labelKey]
    },
    applyFilter() {
      this.$emit('update:localSelected', [...this.internalSelected])
      this.$emit('apply')
    },
    clearSelection() {
      this.internalSelected = []
      this.$emit('clear')
    },
  },
}
</script>

<template>
  <div class="filter-panel" :data-filter="`filter-${title}`">
    <div class="filter-title" style="justify-content: space-between">
      <div class="d-flex align-center mb-4">
        <v-icon size="20" class="me-2 cursor-pointer" @click="$emit('back')"
          >mdi-arrow-left</v-icon
        >
        <span class="filter-header">{{ title }}</span>
      </div>
    </div>
    <div
      ref="filterContainerBox"
      class="filter-container-box"
      :style="{ maxHeight: maxHeight + 'px' }"
    >
      <div class="filter-scrollable">
        <div
          v-for="(item, i) in items"
          :key="`filter-${name}-${item[valueKey]}`"
          :class="
            selectedFilter === 1
              ? 'mb-1 py-2 filter-sub-option'
              : `py-3 ${name}-options filter-sub-option`
          "
          :style="
            selectedFilter === 2
              ? { display: 'flex', alignItems: 'self-start' }
              : {}
          "
        >
          <BaseCheckbox
            v-model="internalSelected"
            :value="item[valueKey]"
            sm
            custom-class="custom-checkbox me-3"
            @update:modelValue="internalSelected = $event"
          >
            <BookingStatusLabel
              v-if="selectedFilter === 1"
              :class="['status-cell', 'status-label', item[valueKey]]"
              :status="$t(`general.${item[valueKey]}`)"
            />
            <div
              v-else-if="selectedFilter === 2"
              class="candidate-wrapper flex items-center"
            >
              <CandidateImage
                :id="item[valueKey]"
                :first-name="item.firstName"
                :last-name="item.lastName"
                size="32"
                :font-size="22"
              />
              <span class="educator-name">{{ getLabel(item) }}</span>
            </div>
            <span
              v-else-if="selectedFilter === 3"
              :class="[name, i % 2 === 0 ? 'pill' : 'pill-2']"
            >
              {{ getLabel(item) }}
            </span>
            <span v-else :class="`${name}`">
              {{ getLabel(item) }}
            </span>
          </BaseCheckbox>
        </div>
      </div>
    </div>
    <div class="filter-footer">
      <div class="d-flex align-center justify-space-between w-100">
        <div class="flex-grow-1">
          <div
            v-show="selectedCount > 0"
            class="cursor-pointer clear-filter"
            :class="colorClass.text.primary400"
            :data-filter="`clear-${name}-filters`"
            @click="clearSelection"
          >
            {{ $t('topFilterBar.filter.clearAll') }}
          </div>
        </div>
        <BaseButton
          :border-radius="'8px'"
          :width="'70px'"
          :height="'30px'"
          class="p-5 apply-btn"
          :disabled="internalSelected.length === 0"
          @click="applyFilter"
        >
          {{ $t('apply') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-top-filter-bar.scss';
</style>
